import React from 'react';

import './ChecklistTaskNavigationButtons.less';
import ChecklistPreviousTaskButton from '../ChecklistPreviousTaskButton';
import ChecklistNextTaskButton from '../ChecklistNextTaskButton';

const ChecklistTaskNavigationButtons = () => (
  <React.Fragment>
    <ChecklistPreviousTaskButton />
    <ChecklistNextTaskButton />
  </React.Fragment>
);

ChecklistTaskNavigationButtons.propTypes = {};

ChecklistTaskNavigationButtons.defaultProps = {};

export default ChecklistTaskNavigationButtons;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistTaskNavigationButtons/ChecklistTaskNavigationButtons.jsx